module.exports = __webpack_public_path__ + "img/fish_cutting.a5050bfc.jpg";